/**
 * The `?rdId=` an admin names to scope an Appointment read (NO-467). Shared so
 * the router and the server gate cannot drift.
 *
 * Matches both id sources the `text` columns actually hold — generated UUIDs and
 * seed-fixtures' literals like `fixture-rd-joy-fuller` — while staying lowercase
 * (the lookup is case-sensitive) and bounded (the id reaches a log field).
 */
const RD_ID_RE = /^[a-z0-9](?:[a-z0-9-]{0,62}[a-z0-9])?$/;

export function isWellFormedRdSelection(rdId: unknown): rdId is string {
  return typeof rdId === "string" && RD_ID_RE.test(rdId);
}
